import { Component, Input } from "@angular/core";
import { Router } from "@angular/router";

import { Store, select } from "@ngrx/store";
import { Observable } from "rxjs";
import  moment from "moment";
import { TranslateService } from "@ngx-translate/core";
import { clientConfig } from "../../constant/app.constant";

@Component({
  selector: "app-pickup",
  templateUrl: "./pick-up.component.html",
  styleUrls: ["./pick-up.component.scss"],
})
export class PickUpComponent {
  @Input() title: any;
  @Input() displayDateTime = true;
  param = {
    streetaddress: "",
    zipcode: "",
    city: "",
    country: "",
    time: "",
    type: "",
    year: "",
    month: "",
    day: "",
    state: "",
    noOfDaysLeft: "",
    additionalAddressInformation: "",
    pickupDate: null,
  };
  displayTime:any=false;
  tenantName = clientConfig.TENANTNAME.toLowerCase().trim();
  merchantName = clientConfig.MERCHANTNAME.toLowerCase().trim();
  collectionTimeStart: "";
  collectionTimeEnd: "";

  pickUpTimeStart = clientConfig.SHIPPING_OPTIONS.collection[0].pickupTimeStart.substring(0, 5);
  pickUpTimeEnd = clientConfig.SHIPPING_OPTIONS.collection[0].pickupTimeEnd.substring(0, 5);
  returnOrder$: Observable<any>;
  constructor(private router: Router, private store: Store<AppState>, private translate: TranslateService) {
    this.returnOrder$ = this.store.pipe(select("returnOrder"));
    var self = this;
    setTimeout(() => {
      self.returnOrder$.subscribe((ro) => {
        const month = ro.deliveryOption.date.month;
        const date = ro.deliveryOption.date.day;
        const noOfDay =
          ro.deliveryOption.date.year + "-" + ro.deliveryOption.date.month + "-" + ro.deliveryOption.date.day;
        self.param = {
          additionalAddressInformation: self.emptyString(ro.orderAddress.additionalAddressInformation),
          streetaddress: self.emptyString(ro.orderAddress.streetAddress),
          city: self.emptyString(ro.orderAddress.city),
          state: self.emptyString(ro.orderAddress.state),
          country: ro.orderAddress.isoCountry,
          zipcode: self.emptyString(ro.orderAddress.zipcode),
          time: ro.deliveryOption.time,
          type: ro.deliveryOption.type,
          day: date < 10 ? "0" + date : date,
          month: month < 10 ? "0" + month : month,
          year: ro.deliveryOption.date.year,
          noOfDaysLeft: self.transform(noOfDay),
          pickupDate: new Date(
            ro.deliveryOption.date.year,
            month - 1,
            date,
            parseInt(ro.deliveryOption.time.split(":")[0]),
            parseInt(ro.deliveryOption.time.split(":")[1])
          ),
        };
        self.displayTime = clientConfig.SHIPPING_OPTIONS.collection[0].preferredPickupTimeDisabled;

        if (clientConfig.SHIPPING_OPTIONS.collection) {
          if (clientConfig.SHIPPING_OPTIONS.collection[0].collectionTimeStart)
            self.collectionTimeStart = clientConfig.SHIPPING_OPTIONS.collection[0].collectionTimeStart.substring(0, 5);
          if (clientConfig.SHIPPING_OPTIONS.collection[0].collectionTimeEnd)
            self.collectionTimeEnd = clientConfig.SHIPPING_OPTIONS.collection[0].collectionTimeEnd.substring(0, 5);
        }
      });
    });
  }

  emptyString(value) {
    if (value === null || value === "" || value === undefined) {
      return (value = "");
    }
    return value + ",";
  }

  transform(date1: any): any {
    const daydiff = moment(date1, "YYYY-MM-DD").diff(moment(new Date()).format("YYYY-MM-DD"), "days");
    return Math.ceil(daydiff);
}
}
